import React from 'react';

const VerifiedAstrologersComponent = () => {
    return (
        <section className="as_about_wrapper as_padderTop80 as_padderBottom80">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-md-12">
                        <h1 className="as_heading text-center">Verified Astrologers</h1>
                        <div className="as_font14 as_padderTop20" style={{lineHeight: '1.8'}}>
                            <p><b>At Astroscope, we believe that trust is the foundation of every consultation.</b></p>
                            <h2>Thorough Verification</h2>
                            <p>Every astrologer on our platform undergoes a rigorous verification process. We check their credentials, certifications, experience, and background to ensure they meet our high standards.</p>
                            <h2>Continuous Assessment</h2>
                            <p>Our team regularly reviews astrologer profiles, user feedback, and consultation quality to maintain the highest standards of service.</p>
                            <h2>Genuine Guidance</h2>
                            <p>We are committed to connecting you with only genuine, qualified, and experienced astrologers. Our astrologers are passionate about helping you and are dedicated to providing honest and insightful guidance.</p>
                            <h2>Transparent Profiles</h2>
                            <p>You can view detailed profiles, ratings, and reviews for each astrologer before starting a consultation, so you can make an informed choice.</p>
                            <h2>Your Feedback Matters</h2>
                            <p>We encourage you to rate and review your experience after every session. Your feedback helps us maintain quality and accountability across our platform.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default VerifiedAstrologersComponent; 